// extracted by mini-css-extract-plugin
export default {"input":"_5ZPrUZuwRtuyPeGtOyyd6m"};